import CloseIcon from "@mui/icons-material/Close";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
    Box,
    Button,
    Card,
    Checkbox,
    CircularProgress,
    Collapse,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Modal,
    Slider,
    Stack,
    Typography,
    Tabs,
    Tab,
    TextField,
    MenuItem,
    Select,
    FormControl,
    InputLabel
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { BIGrey, BIBlue } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { FETCH_TRADES, SAVE_JOB_POST_ALERTS, SAVE_EXTERNAL_JOB_ALERTS, FETCH_EXTERNAL_JOB_TITLES } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import SearchMap from "../sites/SearchMap";

function AddJobAlertModal({ open, onCLose, onRefresh, isExternal = false }) {
    const loginData = useSelector((state) => state.main?.loginData);
    const { multiLanguageData } = useSelector((state) => state?.main);

    const LanguageData = multiLanguageData?.JobPostings || {};
    const {
        TEXT_ADD_JOB_ALERT_HEADER = English.JobPostings.TEXT_ADD_JOB_ALERT_HEADER,
        TEXT_LOCATION = English.JobPostings.TEXT_LOCATION,
        TEXT_SEARCH_LOCATION = English.JobPostings.TEXT_SEARCH_LOCATION,
        TEXT_DISTANCE = English.JobPostings.TEXT_DISTANCE,
        TEXT_CATEGORY_TYPE = English.JobPostings.TEXT_CATEGORY_TYPE,
        TEXT_SEARCH_NAME = English.JobPostings.TEXT_SEARCH_NAME,
        TEXT_ENTER_KEYWORD = English.JobPostings.TEXT_ENTER_KEYWORD,
        TEXT_JOB_TYPE = English.JobPostings.TEXT_JOB_TYPE,
        TEXT_TRADE_SELECT_ONE = English.JobPostings.TEXT_TRADE_SELECT_ONE,
        TEXT_SAVE_ALERT = English.JobPostings.TEXT_SAVE_ALERT
    } = LanguageData || {};

    const [tradeList, setTradeList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTrades, setSelectedTrades] = useState([]);
    const [pageNr, setPageNr] = useState(1);
    const [hasMoreData, setHasMoreData] = useState(false);
    const [isNextDataCalled, setIsNextDataCalled] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [locationDetails, setLocationDetails] = useState();
    const [isTradeExpanded, setIsTradeExpanded] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    // External Alert State
    const [externalCatType, setExternalCatType] = useState("Title");
    const [externalCatName, setExternalCatName] = useState("");
    const [externalJobType, setExternalJobType] = useState("All");

    const categoryOptions = ["Title", "Company", "Job Publisher", "Trade"];
    const jobTypeOptions = ["All", "Full Time", "Part Time", "Contract"];

    useEffect(() => {
        setPageNr(1);
        fetchTradesList(1);
    }, []);

    const fetchTradesList = useCallback(async (pageNumber) => {
        pageNumber === 1 && setIsLoading(true);
        try {
            let obj;
            let apiPath;
            if (isExternal) {
                apiPath = FETCH_EXTERNAL_JOB_TITLES;
                obj = {
                    PageNr: pageNumber,
                    NrOfRecPerPage: 20,
                    FullSearch: "",
                    UserId: loginData?.userInformation?.UserId || "1",
                    IncludeRecordNr: "true",
                    TypeOfObjectReturned: "",
                    FetchAllowedRecordsOnly: false,
                    SearchList: [{}],
                    SortList: [{}]
                };
            } else {
                apiPath = FETCH_TRADES;
                obj = {
                    PageNr: pageNumber,
                    NrOfRecPerPage: 20,
                    FullSearch: "",
                    SearchList: [{}],
                    IncludeRecordNr: true,
                    TypeOfObjectReturned: "NameOnly",
                    FetchAllowedRecordsOnly: true
                };
            }
            const res = await Postrequestcall(apiPath, obj, loginData?.accessToken);
            let nrOfRecords = res.data?.nrOfRecords || 0;
            const resData = res?.data?.data || [];
            const tradesData = resData?.map((value) => {
                return { value: value.id, label: value.typeName || value.name || value.jobTitle || "", isChecked: false };
            });

            setTradeList(prevList => {
                const finalData = pageNumber === 1 ? tradesData : [...prevList, ...tradesData];
                setHasMoreData(nrOfRecords > finalData.length);
                return finalData;
            });
        } catch (error) {
            console.error("Error fetchTradesList :: ", error);
        } finally {
            setIsLoading(false);
            setIsNextDataCalled(false);
        }
    }, [isExternal, loginData]);

    const handleSaveJobAlert = async () => {
        setIsSaving(true);
        try {
            let res;
            if (!isExternal) {
                const payload = {
                    UserId: loginData?.userInformation?.UserId || 0,
                    ReturnRecordId: true,
                    ReturnRecordError: true,
                    SaveList: [
                        {
                            Id: 0,
                            UserId: loginData?.userInformation?.UserId || 0,
                            Latitude: locationDetails?.lat || 0,
                            Longitude: locationDetails?.lng || 0,
                            Radius: locationDetails?.range || 0,
                            TradeId: selectedTrades[0] || 0,
                            Address: locationDetails?.address || "",
                            City: locationDetails?.city || "",
                            Province: locationDetails?.province || "",
                            PostalCode: locationDetails?.postalCode || "",
                            Country: locationDetails?.country || "",
                            ModifiedBy: loginData?.userInformation?.UserId || 0
                        }
                    ]
                }
                res = await Postrequestcall(SAVE_JOB_POST_ALERTS, payload, loginData?.accessToken);
            } else {
                const payload = {
                    UserId: Number(loginData?.userInformation?.UserId),
                    ReturnRecordId: true,
                    ReturnRecordError: true,
                    SaveList: [
                        {
                            Id: 0,
                            UserId: Number(loginData?.userInformation?.UserId),
                            CategoryType: externalCatType,
                            CategoryName: externalCatName,
                            JobType: externalJobType === "All" ? "" : externalJobType,
                            JobTitleId: selectedTrades[0] || 0,
                            ModifiedBy: Number(loginData?.userInformation?.UserId)
                        }
                    ]
                };
                res = await Postrequestcall(SAVE_EXTERNAL_JOB_ALERTS, payload, loginData?.accessToken);
            }

            if (res.status == 200 || res.data?.status) {
                if (onRefresh) {
                    await onRefresh();
                }
                onCLose();
            }
        } catch (error) {
            console.error("Error handleSaveJobAlert :: ", error);
        } finally {
            setIsSaving(false);
        }
    }

    function handleTradeItemClick(index) {
        const newList = tradeList.map((item) => {
            if (item.value === index) {
                return { ...item, isChecked: !item.isChecked };
            }
            return { ...item, isChecked: false };
        });

        setTradeList(newList);

        const clickedItem = newList.find(item => item.value === index);
        if (clickedItem?.isChecked) {
            setSelectedTrades([index]);
        } else {
            setSelectedTrades([]);
        }
    }

    const handleLoadMore = () => {
        if (hasMoreData && !isNextDataCalled) {
            setIsNextDataCalled(true);
            const nextPage = pageNr + 1;
            setPageNr(nextPage);
            fetchTradesList(nextPage);
        }
    };

    const handleSearch = (place) => {
        if (!place) {
            setLocationDetails(null);
            setSearchTerm("");
            return;
        }

        let lat = Number(place.geometry.location.lat());
        let lng = Number(place.geometry.location.lng());

        let address = "";
        let city = "";
        let province = "";
        let postalCode = "";
        let country = "";

        if (place?.address_components.length > 0) {
            for (let i = 0; i < place?.address_components.length; i++) {
                let x = place?.address_components[i];
                if (x.types[0] === "street_number") address += x.long_name + " ";
                if (x.types[0] === "route") address += x.long_name + " ";
                if (x.types[0] === "locality" || x.types[0] === "postal_town") city = x.long_name;
                if (x.types[0] === "administrative_area_level_1") province = x.short_name;
                if (x.types[0] === "postal_code" || x.types[1] === "postal_code") postalCode = x.long_name;
                if (x.types[0] === "country") country = x.long_name;
            }
        }

        let _addressValue = city ? (city + (province ? ", " + province : "")) : address;

        setLocationDetails((preValue) => ({
            ...preValue,
            address: address.trim(),
            city: city,
            province: province,
            postalCode: postalCode,
            country: country,
            lat: lat,
            lng: lng,
            range: preValue?.range || 80
        }));

        setSearchTerm(_addressValue);
    };

    const isAnyChecked = tradeList?.some((option) => option.isChecked);
    const canSaveInternal = isAnyChecked && locationDetails;
    const canSaveExternal = isAnyChecked && externalCatName.trim() !== "";

    return (
        <Modal open={open}>
            <Box className="user-modal-responsive" sx={{ display: 'flex', flexDirection: 'column', height: '100%', maxHeight: '95vh', overflow: 'hidden' }}>
                {/*  Header */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: 'space-between',
                        p: 2,
                        pb: 1
                    }}>
                    <Typography variant="h6" sx={{ fontSize: 18 }}>{TEXT_ADD_JOB_ALERT_HEADER}</Typography>
                    <IconButton onClick={() => onCLose()}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                    {!isExternal ? (
                        /* Internal Alert Fields */
                        <Box sx={{ mb: 3 }}>
                            <Typography sx={{ color: BIGrey, mb: 1 }}>{TEXT_LOCATION}*</Typography>
                            <SearchMap
                                setSearchTerm={setSearchTerm}
                                searchTerm={searchTerm}
                                handleSearch={handleSearch}
                                placeholder={TEXT_SEARCH_LOCATION}
                                from="jobposting"
                                onClear={() => {
                                    setLocationDetails(null);
                                    setSearchTerm("");
                                }}
                            />

                            <Typography variant="subtitle1" sx={{ mt: 2, fontWeight: 600 }}>{TEXT_DISTANCE}</Typography>
                            <Stack flexDirection={"row"} alignItems="center" justifyContent={'space-between'} gap={2}>
                                <Stack flexGrow={1} sx={{ ml: 1 }}>
                                    <Slider
                                        value={locationDetails?.range || 80}
                                        min={5}
                                        max={120}
                                        onChange={(e, value) => {
                                            setLocationDetails((preValue) => ({
                                                ...preValue,
                                                range: value
                                            }))
                                        }}
                                        sx={{ color: BIBlue }}
                                    />
                                </Stack>
                                <Typography sx={{ minWidth: '50px', textAlign: 'right' }}>{locationDetails?.range || 5} km</Typography>
                            </Stack>
                        </Box>
                    ) : (
                        /* External Alert Fields */
                        <Box sx={{ mb: 3 }}>
                            <FormControl fullWidth sx={{ mb: 2 }}>
                                <InputLabel>{TEXT_CATEGORY_TYPE}</InputLabel>
                                <Select
                                    value={externalCatType}
                                    label={TEXT_CATEGORY_TYPE}
                                    onChange={(e) => setExternalCatType(e.target.value)}
                                >
                                    {categoryOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <TextField
                                fullWidth
                                label={`${TEXT_SEARCH_NAME} *`}
                                variant="outlined"
                                value={externalCatName}
                                onChange={(e) => setExternalCatName(e.target.value)}
                                sx={{ mb: 2 }}
                                placeholder={TEXT_SEARCH_NAME}
                            />

                            <FormControl fullWidth sx={{ mb: 2 }}>
                                <InputLabel>{TEXT_SEARCH_NAME}</InputLabel>
                                <Select
                                    value={externalJobType}
                                    label={TEXT_JOB_TYPE}
                                    onChange={(e) => setExternalJobType(e.target.value)}
                                >
                                    {jobTypeOptions.map(opt => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}

                    {/* Trade List Section (Common) */}
                    <Box id="scrollable-trade-list">
                        <Stack
                            flexDirection={"row"}
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{ mb: 1 }}
                        >
                            <Typography variant="h6" sx={{ fontSize: 16 }}>{TEXT_TRADE_SELECT_ONE}</Typography>
                            <IconButton
                                size="small"
                                onClick={() => setIsTradeExpanded(!isTradeExpanded)}
                            >
                                {isTradeExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </IconButton>
                        </Stack>

                        <Collapse in={isTradeExpanded}>
                            {isLoading ? (
                                <Loader />
                            ) : (
                                <List disablePadding>
                                    <InfiniteScroll
                                        dataLength={tradeList?.length}
                                        next={handleLoadMore}
                                        hasMore={hasMoreData}
                                        loader={hasMoreData && <Box sx={{ display: "flex", justifyContent: "center", py: 1 }}><Loader /></Box>}
                                        scrollableTarget="scrollable-trade-list"
                                    >
                                        {tradeList?.map((option) => (
                                            <Card
                                                key={option.value}
                                                sx={{ mb: 1, border: '1px solid #eee', boxShadow: 'none' }}>
                                                <ListItem disablePadding>
                                                    <ListItemButton onClick={() => handleTradeItemClick(option.value)} dense>
                                                        <ListItemIcon sx={{ minWidth: "36px" }}>
                                                            <Checkbox edge="start" checked={option.isChecked} disableRipple size="small" />
                                                        </ListItemIcon>
                                                        <ListItemText primary={option.label} />
                                                    </ListItemButton>
                                                </ListItem>
                                            </Card>
                                        ))}
                                    </InfiniteScroll>
                                </List>
                            )}
                        </Collapse>
                    </Box>
                </Box>

                <Box
                    sx={{
                        p: 2,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        backgroundColor: 'white'
                    }}
                >
                    <Button
                        variant="contained"
                        fullWidth
                        disabled={(isExternal ? !canSaveExternal : !canSaveInternal) || isSaving}
                        onClick={handleSaveJobAlert}
                        sx={{
                            backgroundColor: BIBlue,
                            height: '45px',
                            fontWeight: 600,
                            '&:hover': { backgroundColor: '#0056b3' }
                        }}
                    >  {isSaving ? <CircularProgress size={24} color="inherit" /> : TEXT_SAVE_ALERT}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}

export default AddJobAlertModal;
